function loadError(error) {
    throw new URIError(`The script ${error.target.src} is not accessible.`);
}
function appendScript(src, callback) {
    const body = document.body || document.getElementsByTagName('body')[0];
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.onerror = loadError;
    script.onload = callback;
    body.appendChild(script);
    script.src = src;
}
export function addScript(src, callback) {
    const { define, require } = window;
    if (define && define.amd && require) {
        // viewer require-js found
        require([src], callback);
        return;
    }
    if (document.readyState === 'complete' ||
        document.readyState === 'interactive') {
        appendScript(src, callback);
    }
    else {
        document.addEventListener('DOMContentLoaded', () => {
            appendScript(src, callback);
        });
    }
}
export function addStyle(src) {
    const link = document.createElement('link');
    link.type = 'text/css';
    link.href = src;
    link.rel = 'stylesheet';
    document.getElementsByTagName('head')[0].appendChild(link);
}
//# sourceMappingURL=load.js.map